import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';
import { getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth';

// Your Firebase config - replace with your actual config
const firebaseConfig = {
  apiKey: "AIzaSyBxnb-e63Bc8JvqLuaf7_GU8ekA_ihtD-8",
  authDomain: "novjivot-church.firebaseapp.com",
  databaseURL: "https://novjivot-church-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "novjivot-church",
  storageBucket: "novjivot-church.firebasestorage.app",
  messagingSenderId: "1059945764196",
  appId: "1:1059945764196:web:b090fb3fdb37763bee1671",
  measurementId: "G-4QSV13J9WX"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Realtime Database and get a reference to the service
export const database = getDatabase(app);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Set authentication persistence to local (persists even when browser is closed)
setPersistence(auth, browserLocalPersistence).catch((error) => {
  console.error('Error setting auth persistence:', error);
});

export default app;
